import { isValidElement } from "react";

function _type_of(obj) {
	"@swc/helpers - typeof";
	return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function filterRootHTML(el) {
	var htmlProps;
	var bodyProps;
	var head;
	function traverse(element) {
		if (!element || (typeof element === "undefined" ? "undefined" : _type_of(element)) !== "object") return element;
		if (Array.isArray(element)) return element.map(traverse);
		var reactElement = element;
		var { type, props } = reactElement;
		if (type === "html") {
			if (props && (typeof props === "undefined" ? "undefined" : _type_of(props)) === "object" && "children" in props) {
				var { children: children2, ...restProps } = props;
				htmlProps = restProps;
				return traverse(children2);
			}
			return null;
		}
		if (type === "head") {
			head = reactElement;
			return null;
		}
		if (type === "body") {
			if (props && (typeof props === "undefined" ? "undefined" : _type_of(props)) === "object" && "children" in props) {
				var { children: children1, ...restProps1 } = props;
				bodyProps = restProps1;
				return traverse(children1);
			}
			return null;
		}
		if (isValidElement(element) && typeof element.type === "string" && element.type.toLowerCase() === element.type) {
			if (element.props && _type_of(element.props) === "object" && "children" in element.props) return traverse(element.props.children);
			return null;
		}
		return element;
	}
	return {
		children: traverse(el) || el,
		htmlProps,
		bodyProps,
		head
	};
}

export { filterRootHTML };